export const GET_PRODUCT_FOR_REGISTER_WARRANTY_DATA_ENDPOINT='/Warranty/GetProducts';